import { render, staticRenderFns } from "./abstract-car-brand-field.vue?vue&type=template&id=64f4537e&scoped=true"
import script from "./abstract-car-brand-field.vue?vue&type=script&lang=js"
export * from "./abstract-car-brand-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f4537e",
  null
  
)

export default component.exports